import { fromJS } from 'immutable';
import normaliseResponse from 'utils/normaliseResponse';

import * as constants from 'actions/sessions/constants';
import initialState from './initialState';

// Note: unlike other reducers, Session data is not cached per project,
// but over-written each time
export default (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_ACTIVE_SESSIONS_SUCCESS: {
      const { sessions } = action;

      const normalisedResponse = normaliseResponse(
        sessions,
        undefined,
        'streaming_session_id'
      );
      const { allIds, byId } = normalisedResponse;

      return state
        .setIn(['active', 'byId'], fromJS(byId))
        .setIn(['active', 'allIds'], fromJS(allIds));
    }

    case constants.GET_HISTORICAL_SESSIONS_SUCCESS: {
      const { pagination, sessions } = action;

      const normalisedResponse = normaliseResponse(
        sessions,
        undefined,
        'streaming_session_id'
      );
      const { allIds, byId } = normalisedResponse;

      return state
        .setIn(['historical', 'pagination'], fromJS(pagination))
        .setIn(['historical', 'byId'], fromJS(byId))
        .setIn(['historical', 'allIds'], fromJS(allIds));
    }

    default:
      return state;
  }
};
